import { Modal } from "@almafintech/react-components";
import moment from "moment";
import { useEffect, useState } from "react";
import styles from "./RedirectionModal.module.scss";
import { texts } from "../../i18n";

export const Countdown = ({
  to,
  onCountdownEnd: handleCountdownEnd,
}: {
  to: Date;
  onCountdownEnd?: () => void;
}) => {
  const [hasEnded, setHasEnded] = useState(false);

  const [bufferedTimestamp, setBufferedTimestamp] = useState<string>(
    moment(-moment().diff(to)).format("mm:ss")
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setBufferedTimestamp(moment(-moment().diff(to)).format("mm:ss"));
      setHasEnded(-moment().diff(to) <= 0);
    }, 1000);
    return () => clearInterval(timer);
  });

  useEffect(() => {
    if (hasEnded) handleCountdownEnd?.();
  }, [bufferedTimestamp]);

  return <span>{hasEnded ? "00:00" : bufferedTimestamp}</span>;
};

const RedirectionModal = ({
  isOpen,
  language = "es",
}: {
  isOpen?: boolean;
  language?: "en" | "es";
}) => {
  const { modalBase, container, title, countdown } = styles;

  const [toDate] = useState(moment().add(5, "minutes").toDate());
  const [isCountdownOver, setIsCountdownOver] = useState(false);

  return (
    <Modal
      isOpen={isOpen}
      backdrop="blur"
      hideCloseButton
      classNames={{ base: modalBase }}
    >
      <div
        className={`flex flex-col gap-4 h-full justify-center items-center ${container}`}
      >
        <div className="flex flex-col items-center">
          <span className={countdown}>
            <Countdown
              to={toDate}
              onCountdownEnd={() => setIsCountdownOver(true)}
            />
          </span>
          <span className={title}>{texts[language].redirectTitle}</span>
        </div>
        <span>
          {isCountdownOver
            ? texts[language].redirectTipAfterCountdownDone
            : texts[language].redirectTipBeforeCountdownDone}
        </span>
      </div>
    </Modal>
  );
};

export default RedirectionModal;
